import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { useDispatch, useSelector } from "react-redux";
import { SHUTTLE_BUS_BOOKING_ROUTE_LIST } from "../../../routes";
import { Button } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";

import { Checkbox, TextBox } from "@progress/kendo-react-inputs";
import { createAndUpdateSetMaximum, fetchSetMaximumDetail } from "../../../store/shuttle_bus_booking/set_maximum";
import BackIcon from "../../../assets/communication/Back.svg";
import { createAndUpdateRoute, createAndUpdateSpecialRoute, fetchOrdinaryRouteList, fetchRouteDetail, fetchSpecialRouteDetail } from "../../../store/shuttle_bus_booking/shuttle_bus_route";
import { fetchSetStationList } from "../../../store/shuttle_bus_booking/set_station";
import { ManageRoute } from "./route";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import DatePicker from "react-datepicker";
import BUS from "../../../assets/Runtime/ic_ bus.svg";
import MapIcon from "../../../assets/shuttle_bus_booking/ic_pin.svg";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import moment from "moment/moment";

export const ShuttleBusBookingSpecialRouteAdd = () => {

  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);

  const [errors, setErrors] = useState(false);
  const [showRequiredFieldError, setShowRequiredFieldError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showValidateError, setShowValidateError] = useState(false);
  const [showDetailPopup, setShowDetailPopup] = useState(false);

  const [id, setId] = useState(
    query.get("id") ?? ""
  );

  const userPermissions = getUserPermission();

  const AddPermssion = checkPermission(
    userPermissions,
    "bus_booking.create_special_days"
  );

  const [editData, setEditData] = useState({
    name: "",
    start_date: "",
    end_date: "",
    active_route_ids: [],
    status: "Active",
    custom_routes: [],
  });

  const [customRoutes, setCustomRoutes] = useState([]);
  const [activeCustomRoutes, setActiveCustomRoutes] = useState([]);
  const [activeCustomData, setActiveCustomData] = useState({});
  const [showCustomRoutePopup, setShowCustomRoutePopup] = useState(false);
  const [showCustomRouteDetailPopup, setShowCustomRouteDetailPopup] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);




  const { set_station_list } = useSelector(
    (state) => state.shuttleBusSetStation
  );

  const { detail_data, detail_loading, ordinary_route_list, special_detail_loading, special_detail_data } = useSelector(
    (state) => state.shuttleBusRoute
  );

  const getData = async () => {
    dispatch(fetchSetStationList(id));
    dispatch(fetchSpecialRouteDetail(id));
    dispatch(fetchOrdinaryRouteList());

  };


  useEffect(() => {
    getData();
  }, [id]);


  useEffect(() => {

    if (special_detail_data && id) {
      setEditData({
        name: special_detail_data.name,
        active_route_ids: special_detail_data.active_route_ids,
        status: special_detail_data.status,
        custom_routes: special_detail_data.custom_routes,
        start_date: moment(special_detail_data.start_date, "YYYY-MM-DD").toDate(),
        end_date: moment(special_detail_data.end_date, "YYYY-MM-DD").toDate(),
      });
      setCustomRoutes(special_detail_data.custom_routes);
    }

  }, [special_detail_data]);


  const getRouteDetails = async (route_id) => {
    dispatch(fetchRouteDetail(route_id));
  }


  const handleSubmit = () => {
    if (checkMandatoryFields()) return;

    const params = {
      ...editData,
      custom_routes: customRoutes,
      start_date: moment(editData.start_date).format("YYYY-MM-DD"),
      end_date: moment(editData.end_date).format("YYYY-MM-DD"),
    };
    setLoading(true);

    dispatch(createAndUpdateSpecialRoute({ data: params, id })).then((res) => {
      const { payload } = res;
      if (payload.status === "success") {

        setLoading(false);
        if (id) {
          navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=special`);
        } else {
          setShowSuccessPopup(true);
        }
      } else {
        setLoading(false);
      }
    });


  };

  const handleCloseDialog = () => {
    setShowSuccessPopup(false);
    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=special`);
  };


  const checkMandatoryFields = () => {
    const { name, start_date, end_date } = editData;
    let hasError = false;

    if (!name || !start_date || !end_date) {
      console.error("All fields must be filled.");
      hasError = true;
      console.log('sadfasdfa');
      console.log(start_date + end_date);


    }


    setShowRequiredFieldError(hasError);
    setShowValidateError(hasError);
    return hasError;
  }



  const parseStationName = (locationString) => {
    const safeString = locationString || '';
    const parts = safeString.match(/^(.*)\((.*)\)$/);
    const mainName = parts ? parts[1].trim() : safeString;
    const subtitle = parts ? `(${parts[2].trim()})` : '  ';

    return { mainName, subtitle };
  };


  const getSortIcon = () => {
    return (<svg width="10" height="14" viewBox="0 0 10 14">
      <path d="M0 6 L5 1 L10 6 Z" fill="#999" />
      <path d="M0 8 L5 13 L10 8 Z" fill="#999" />
    </svg>);
  };



  const callback_handleBackBtn = (e) => {

    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=special`);

  };



  const buildRouteStops = (routes) => {
    const elements = [];
    const middleElements = [];
    const total = routes.length;

    if (routes.length == 0) {
      return <div>No Data</div>
    }

    for (let i = 0; i < total; i++) {
      const stop = routes[i];
      const isFirst = i === 0;
      const isLast = i === total - 1;
      const isMiddle = !isFirst && !isLast;

      // Parse name
      const { mainName, subtitle } = parseStationName(stop.station_name);

      if (isFirst) {
        elements.push(
          <div key={stop.station_id} className="location-container" style={{ marginLeft: '5px' }}>
            <div className="pin-icon">
              <img alt="" src={BUS} className="shuttle_bus_booking_map_icon" />
            </div>
            <div className="text-container">
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
      }
      else if (isLast) {
        if (routes.length > 2) {
          elements.push(
            <div className="shuttle_bus_detail_route_second_child_box">
              <div className="shuttle_bus_detail_route_second_child_box_arrow_main_box">
                <div className="shuttle_bus_detail_route_second_child_box_arrow_tail"></div>

                <div className="shuttle_bus_detail_route_second_child_box_arrow_head">
                  &#x25BC;
                </div>
              </div>
              <div>{middleElements}</div>
            </div>
          )
        }
        elements.push(
          <div key={stop.station_id} className="location-container" style={{ marginLeft: '5px' }}>
            <div className="pin-icon">
              <img alt="" src={MapIcon} className="shuttle_bus_booking_map_icon" />
            </div>
            <div className="text-container">
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
      } else if (!isFirst) {
        middleElements.push(
          <div key={stop.station_id} className="location-container">
            <div className="text-container" >
              <span className="main-name">{mainName}</span>
              <span className="subtitle">{subtitle}</span>
              <div className="pickup-time-container">
                <div className="pickup-time">{stop?.time}</div>
              </div>
            </div>
          </div>
        );
        middleElements.push(
          <div style={{ height: '15px' }}></div>
        );

      }

    }

    return elements;
  };

  const derivePickupAndDestination = (routes) => {
    if (!routes || routes.length === 0) {
      return {
        pickup_station_id: "",
        pickup_station_name: "",
        pickup_time: "",
        destination_station_id: "",
        destination_station_name: "",
        destination_time: "",
      };
    }

    const first = routes[0];
    const last = routes[routes.length - 1];

    return {
      pickup_station_id: first.station_id || "",
      pickup_station_name: first.station_name || "",
      pickup_time: first.time || "",

      destination_station_id: last.station_id || "",
      destination_station_name: last.station_name || "",
      destination_time: last.time || "",
    };
  };



  return (
    <>
      {AddPermssion ? (
        <div style={{ height: "calc(100% - 75px)" }}>

          {errors && (
            <Dialog
              width={400}
              title={"Message"}
              onClose={() => setErrors(false)}
              className="error-message"
            >
              <p>{errors}</p>
            </Dialog>
          )}

          {showSuccessPopup && (
            <Dialog
              className="alert-form"
              title={"Alert"}
              width={400}
              // height={280}
              onClose={handleCloseDialog}
            >
              <p>Successfully Saved</p>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "150px",
                    height: "40px",
                    borderRadius: "5px",
                    background: "#eb6e1f",
                    color: "white",
                    cursor: "pointer",
                  }}
                  onClick={handleCloseDialog}
                >
                  OK
                </div>
              </div>
            </Dialog>
          )}

          {showRequiredFieldError && (
            <Dialog
              className="information-details-alert-form"
              title={"Alert"}
              onClose={() => setShowRequiredFieldError(false)}
            >
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                Please fill in all the required fields.
              </p>
            </Dialog>
          )}

          {showDetailPopup && (

            <Dialog
              className="alert-form"
              title={"Route Details"}
              width={700}
              // height={280}
              onClose={() => setShowDetailPopup(false)}
            >

              <div className="location-route-container">
                {
                  detail_loading ? (
                    <Loader
                      type="converging-spinner"
                      style={{
                        width: "100%",
                        height: "calc(100% - 75px)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "#ffffff4d",
                        position: "absolute",
                        zIndex: "999",
                      }}
                    />
                  ) : buildRouteStops(detail_data?.routes || [])
                }
              </div>
            </Dialog>

          )}

          {showCustomRouteDetailPopup && (

            <Dialog
              className="alert-form"
              title={"Route Details"}
              width={700}
              // height={280}
              onClose={() => setShowCustomRouteDetailPopup(false)}
            >

              <div className="location-route-container">
                {
                  buildRouteStops(activeCustomRoutes || [])
                }
              </div>
            </Dialog>

          )}


          {showCustomRoutePopup && (

            <Dialog
              className="alert-form"
              title={"Route Details"}
              width={1200}
              height={700}
              onClose={() => setShowCustomRoutePopup(false)}
            >

              <div className="shuttle_bus_booking_popup_scroll_box">


                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Bus Name <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={activeCustomData.bus_name}
                      onChange={(e) =>
                        setActiveCustomData({
                          ...activeCustomData,
                          bus_name: e.target.value
                        })
                      }
                    />

                  </div>
                </div>

                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Route Setting
                  </div>
                  <div>
                    <ManageRoute routes={activeCustomRoutes} setRoutes={setActiveCustomRoutes} stations={set_station_list || []} showValidateError={showValidateError} />

                  </div>
                </div>
              </div>

              <DialogActionsBar>
                <button
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base custom-route-cancel-button "
                  onClick={() => {
                    setActiveCustomRoutes([]);
                    setActiveCustomData({})
                    setShowCustomRoutePopup(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base custom-route-submit-button "
                  onClick={() => {
                    const derived = derivePickupAndDestination(activeCustomRoutes);

                    const newRoute = { ...activeCustomData, ...derived, routes: activeCustomRoutes };


                    const existingIndex = customRoutes.findIndex(r => r.route_id === newRoute.route_id);

                    let updatedRoutes;

                    if (existingIndex !== -1) {
                      // Replace / update the existing one
                      updatedRoutes = customRoutes.map((r, i) =>
                        i === existingIndex ? newRoute : r
                      );
                    } else {
                      // Add as new
                      updatedRoutes = [...customRoutes, newRoute];
                    }

                    setCustomRoutes(updatedRoutes);
                    setActiveCustomRoutes([]);
                    setActiveCustomData({})
                    setShowCustomRoutePopup(false);
                  }}
                >
                  Submit
                </button>
              </DialogActionsBar>
            </Dialog>

          )}



          {(detail_loading || loading) && (
            <Loader
              type="converging-spinner"
              style={{
                width: "100%",
                height: "calc(100% - 75px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#ffffff4d",
                position: "absolute",
                zIndex: "999",
              }}
            />
          )}

          <div className="shuttle_bus_booking_body">
            <div className="shuttle_bus_booking_addheader" >
              <div className="back-title-group" onClick={(e) => callback_handleBackBtn(e)}>
                <img src={BackIcon} className="back-icon" />
                <span className="back-text">Back</span>
              </div>
            </div>
          </div>

          <div className="main-shuttle-bus-container">
            <div className="main-poll-survey">

              <div className="shuttle_bus_booking_create_scroll_box">


                <div className="shuttle_bus_booking_create_item_main_box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Special day name <span style={{ color: "red" }}>*</span>
                  </div>
                  <div>
                    <TextBox
                      className="shuttle_bus_booking_create_item_main_box_field"
                      value={editData.name}
                      onChange={(e) =>
                        setEditData({
                          ...editData,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>

                <div className="shuttle_bus_booking_create_item_main_box_title" style={{ marginTop: '20px', marginBottom: '25px' }}>
                  Special Day Route Route Setting
                </div>

                <div className="shuttle_bus_booking_date_layout">
                  <div className="shuttle_bus_booking_main_box margin-bottom">
                    <div className="shuttle_bus_booking_create_item_main_box_title">Start Date <span style={{ color: "red" }}>*</span></div>
                    <div>
                      <DatePicker
                        dateFormatCalendar="MMMM"
                        className="poll-survey-date-picker"
                        selected={editData.start_date}
                        dateFormat="dd/MM/yyyy"
                        minDate={new Date()}
                        onChange={(date) => {
                          setEditData((prevData) => ({
                            ...prevData,
                            start_date: date,
                          }));
                        }}
                        customInput={<CustomDatePicker />}
                      />
                    </div>

                  </div>

                  <div className="shuttle_bus_booking_main_box margin-bottom">
                    <div className="shuttle_bus_booking_main_box_title">End Date <span style={{ color: "red" }}>*</span></div>
                    <div>
                      <DatePicker
                        dateFormatCalendar="MMMM"
                        selected={editData.end_date}
                        className="poll-survey-date-picker"
                        minDate={new Date()}
                        dateFormat="dd/MM/yyyy"

                        onChange={(date) => {
                          setEditData((prevData) => ({
                            ...prevData,
                            end_date: date,
                          }));
                        }}
                        customInput={<CustomDatePicker />}
                      />
                    </div>
                  </div>

                </div>

                <div className="shuttle-bus-booking-status-route-box">
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    Route Setting
                  </div>
                  <div style={{
                    marginTop: "10px",
                    border: "1px solid #eee",
                    borderRadius: "5px",
                    maxHeight: "500px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}>

                    <table className="shuttle-bus-booking-detail-table">
                      <thead>
                        <tr>
                          <th>
                            Route ID {getSortIcon()}
                          </th>
                          <th>
                            Bus Name {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Points {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Time {getSortIcon()}
                          </th>
                          <th>
                            Last Destination {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Time {getSortIcon()}
                          </th>
                          <th>
                            Status {getSortIcon()}
                          </th>
                          <th>
                            Action {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>

                        {(ordinary_route_list || []).map((route, index) => (
                          <tr key={`route_${index}`} style={{ height: "100px" }}>
                            <td>{route?.route_id}</td>
                            <td>{route?.bus_name}</td>
                            <td>{route?.pickup_station_name}</td>
                            <td>{route?.pickup_time}</td>
                            <td>{route?.destination_station_name}</td>
                            <td>{route?.destination_time}</td>
                            <td style={{ textAlign: "center" }}>
                              <Checkbox
                                style={{ border: "1px solid #CCCCCC" }}
                                name={`route_status_${index}`}
                                value={`route_status_${index}`}
                                onChange={(e) => {

                                  const id = route.route_id;
                                  setEditData((prevData) => {
                                    let newActive = [...(prevData.active_route_ids || [])];
                                    if (e.value) {
                                      if (!newActive.includes(id)) {
                                        newActive.push(id);
                                      }
                                    } else {
                                      newActive = newActive.filter(x => x !== id);
                                    }
                                    return {
                                      ...prevData,
                                      active_route_ids: newActive,
                                    };
                                  });
                                }}
                                checked={editData.active_route_ids?.includes(route?.route_id)}
                              />
                            </td>
                            <td><Button
                              className="shuttle-bus-booking-detail-btn font-family-poppins"
                              onClick={() => {
                                getRouteDetails(route?.route_id);
                                setShowDetailPopup(true);
                              }}
                            >
                              Details
                            </Button>
                            </td>


                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>
                </div>


                <div className="shuttle-bus-booking-status-route-box" style={{ marginBottom: '10px' }}>
                  <div className="shuttle_bus_booking_create_item_main_box_title">
                    New custom routes
                  </div>
                  <div style={{
                    marginTop: "10px",
                    border: "1px solid #eee",
                    borderRadius: "5px",
                    maxHeight: "500px",
                    overflowY: "auto",
                    overflowX: "hidden",
                  }}>

                    <table className="shuttle-bus-booking-detail-table">
                      <thead>
                        <tr>
                          <th>
                            Route ID {getSortIcon()}
                          </th>
                          <th>
                            Bus Name {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Points {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Time {getSortIcon()}
                          </th>
                          <th>
                            Last Destination {getSortIcon()}
                          </th>
                          <th>
                            Pick-Up Time {getSortIcon()}
                          </th>
                          <th>
                            Action {getSortIcon()}
                          </th>

                        </tr>
                      </thead>
                      <tbody>

                        {(customRoutes || []).map((route, index) => (
                          <tr key={`custom_route_${index}`} style={{ height: "100px" }}>
                            <td>{route?.route_id}</td>
                            <td>{route?.bus_name}</td>
                            <td>{route?.pickup_station_name}</td>
                            <td>{route?.pickup_time}</td>
                            <td>{route?.destination_station_name}</td>
                            <td>{route?.destination_time}</td>
                            <td>
                              <DropDownList
                                size={"large"}
                                fillMode={"solid"}
                                rounded={"large"}
                                // className="action-btn-dropdown"
                                data={['Details', 'Edit', 'Delete']}
                                valueRender={valueRender}
                                itemRender={itemRender}
                                defaultValue={"Action"}
                                value={"Action"}
                                onChange={(e) => {
                                  const action = e.target.value;

                                  if (action === 'Details') {
                                    // history.push(`/details/${props.dataItem.id}`);
                                    // or open modal, etc.
                                    setActiveCustomRoutes(route?.routes || []);
                                    setShowCustomRouteDetailPopup(true);

                                  }
                                  else if (action === 'Edit') {
                                    setActiveCustomRoutes(route?.routes || []);
                                    setActiveCustomData(route);
                                    setShowCustomRoutePopup(true);

                                  }
                                  else if (action === 'Delete') {
                                    if (window.confirm(`Delete ${route?.bus_name}?`)) {
                                      setCustomRoutes(prevRoutes =>
                                        prevRoutes.filter(r => r.route_id !== route?.route_id)
                                      );

                                    }
                                  }
                                }}
                                style={{
                                  fontSize: "15px",
                                  backgroundColor: "#ffffff",
                                  color: "#EB6E1F",
                                  borderColor: "#EB6E1F",
                                  textAlign: "center",
                                  borderRadius: "8px",
                                }}
                              />
                            </td>
                          </tr>
                        ))}

                      </tbody>
                    </table>
                  </div>

                  <Button
                    className="shuttle-bus-booking-detail-btn font-family-poppins"
                    onClick={() => {
                      setActiveCustomRoutes([]);
                      setActiveCustomData({
                        ...activeCustomData,
                        bus_name: '',
                        route_id: new Date().toISOString().replace(/[-:T.]/g, '').slice(0, 14) +
                          Math.random().toString(36).slice(2, 6).toUpperCase(),
                      })
                      setShowCustomRoutePopup(true);

                    }}
                  >
                    + Add
                  </Button>
                </div>

                <div className="shuttle-bus-booking-status-main-box margin-bottom">
                  <Checkbox
                    style={{ border: "1px solid #CCCCCC" }}
                    name="userVisibility"
                    value="userVisibility"
                    onChange={(e) => {

                      setEditData((prevData) => ({
                        ...prevData,
                        status: e.target.value ? 'Active' : 'Inactive',
                      }));
                    }}
                    checked={editData.status == 'Active'}
                  />
                  <label>Bus route inactive</label>
                </div>



              </div>
            </div>

            <div className="campaigns-survey-footer">
              <div className="footer-left-btn-groups">
                <Button
                  className="footer-previous-btn font-family-poppins"
                  onClick={() => {
                    navigate(`${SHUTTLE_BUS_BOOKING_ROUTE_LIST}?type=special`);
                  }}
                >
                  Cancel
                </Button>
              </div>


              <div className="footer-right">


                <Button
                  className="footer-next-btn"
                  onClick={(e) => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>
              </div>


            </div>
          </div>



        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}
    </>
  );
};


const itemRender = (li, itemProps) => {
  const index = itemProps.index;
  const itemChildren = (
    <span
      style={{
        display: "flex",
      }}
    >
      {li.props.children}
    </span>
  );
  return React.cloneElement(li, li.props, itemChildren);
};

const valueRender = (element, value) => {
  if (!value) {
    return element;
  }
  const children = [
    <span>&nbsp;&nbsp;&nbsp;&nbsp; {element.props.children}</span>,
  ];
  return React.cloneElement(
    element,
    {
      ...element.props,
    },
    children
  );
};
